"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainProfileHistory from '../../components/admin/ClientHistory/user/MainProfileHistroy'

const ProfileHistory = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainProfileHistory/>
    </main>
  </div>
  )
}

export default ProfileHistory
